import { render } from "./AttrImage.vue?vue&type=template&id=c884423a&scoped=true"
import script from "./AttrImage.vue?vue&type=script&lang=js"
export * from "./AttrImage.vue?vue&type=script&lang=js"

import "./AttrImage.vue?vue&type=style&index=0&id=c884423a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c884423a"],['__file',"src/components/widgets/components_core/AttrImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c884423a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c884423a', __exports__)) {
    api.reload('c884423a', __exports__)
  }
  
  module.hot.accept("./AttrImage.vue?vue&type=template&id=c884423a&scoped=true", () => {
    api.rerender('c884423a', render)
  })

}


export default __exports__